<template>
  <svg v-bind="attrs">
    <rect
      width="20"
      height="20"
      fill="#009B3A"
    />
    <path
      d="M10,5 16,10 10,15 4,10 Z"
      fill="#FEDF00"
    />
    <circle
      cx="10"
      cy="10"
      r="4"
      fill="#002776"
    />
    <path
      d="M7,8.5 Q10,7 13,8.5"
      fill="none"
      stroke="white"
      stroke-width="0.7"
      stroke-linecap="round"
    />
    <path
      d="M7,10 Q10,12 13,10"
      fill="none"
      stroke="white"
      stroke-width="0.7"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconAttributes } from '@/utils/icons';

const attrs = iconAttributes({ width: 20, height: 20 });
</script>
